<template>
  <div class="mask">
    <div class="bg"></div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.mask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}
</style>


// WEBPACK FOOTER //
// src/components/common/Modal/ModalMask.vue